(function ($) {
	$(document).on('click', '.tabbed-content-inner-list button', function (e) {
		e.preventDefault();
		changeTab(
			'#' + $(this).siblings('.active').first().attr('id'),
			'#' + $(this).attr('id')
		);
	});

	$(document).on(
		'keydown',
		'.tabbed-content-inner-list button',
		function (e) {
			const currentTab = $(this).attr('id');
			let newTabElement = [];
			switch (e.keyCode) {
				case 39: // Left
					newTabElement = $(this).next('.details-tab-selector');
					break;
				case 37: // Left
					newTabElement = $(this).prev('.details-tab-selector');
					break;
			}
			if (newTabElement.length) {
				const newTab = newTabElement.attr('id');
				$('#' + newTab).focus();
				changeTab('#' + currentTab, '#' + newTab);
			}
		}
	);

	function changeTab(currentTab, newTab) {
		const currentTabPanel = '#' + $(currentTab).attr('aria-controls');
		$(currentTab).removeClass('active');
		$(currentTab).attr('aria-selected', false);
		$(currentTab).attr('tabindex', '-1');
		$(currentTabPanel).removeClass('active');
		$(currentTabPanel).attr('tabindex', '-1');

		const newTabPanel = '#' + $(newTab).attr('aria-controls');
		$(newTab).addClass('active');
		$(newTab).attr('aria-selected', true);
		$(newTab).attr('tabindex', '0');
		$(newTabPanel).addClass('active');
		$(newTabPanel).attr('tabindex', '0');
	}
})(jQuery);
